import React from 'react';
import { useLocation } from 'react-router-dom';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { P } from '../../components/ui';

const messageByNcode: Record<string, string> = {
  // Session expired / unauthorized.
  '2': 'Your session has expired. Please sign in again.',
  // Session conflict (another session took over).
  '3': 'You have been signed out because your session is being used elsewhere. Please sign in again.',
  // Tenant switch detected.
  '4': 'You attempted to switch tenant. Please return to the tenant sign-in page you intended to use and sign in again.',
};

function GlobalErrorScreen({ messageOverride }: { messageOverride?: string }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search || '');
  const ncode = params.get('ncode') || '';
  const loggedOut = params.get('loggedOut') || '';

  const message =
    messageOverride ||
    (loggedOut === '1'
      ? 'You have been signed out.'
      : (ncode && messageByNcode[ncode]) || 'Sorry, there is a problem with the service.');

  return (
    <PageTemplate>
      <h1 className="govuk-heading-l">Something has gone wrong!</h1>
      <P>{message}</P>
    </PageTemplate>
  );
}

export default GlobalErrorScreen;

